// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__1I0VK","title":"classes_title__1EcIQ","cards-container":"classes_cards-container__1wost","view-more-container":"classes_view-more-container__3lQtd"};